// Every heading/label printed on an invoice. An empty string hides the label
// (and, for itemQuantityLabel, the quantity column) in the PDF.
export const LABEL_FIELDS = [
  { name: "documentTitleLabel", label: "Document title" },
  { name: "invoiceNumberLabel", label: "Invoice number" },
  { name: "senderAddressLabel", label: "Sender label" },
  { name: "recipientAddressLabel", label: "Recipient label" },
  { name: "issueDateLabel", label: "Invoice Date" },
  { name: "dueDateLabel", label: "Invoice Due" },
  { name: "fromAndToDateLabel", label: "Service Period" },
  { name: "itemTitleLabel", label: "Product" },
  { name: "itemQuantityLabel", label: "Quantity" },
  { name: "itemUnitPriceLabel", label: "Unit Price" },
  { name: "itemLineTotalLabel", label: "Line Total" },
  { name: "subTotalLabel", label: "Subtotal" },
  { name: "discountLabel", label: "Discount" },
  { name: "taxLabel", label: "Tax" },
  { name: "totalLabel", label: "Total" },
  { name: "footNoteLeftLabel", label: "Foot note left" },
  { name: "footNoteRightLabel", label: "Foot note right" },
] as const;

export type LabelName = (typeof LABEL_FIELDS)[number]["name"];

export const LABEL_NAMES = LABEL_FIELDS.map((field) => field.name);

export const DEFAULT_QUANTITY_LABEL = "Quantity";

/** Languages a customer's invoices can be labelled in: every UI language (label-presets.ts). */
export { LOCALES as INVOICE_LANGUAGES, type Locale as InvoiceLanguage } from "@/i18n/languages";
